export { BankAccountPaymentField } from './BankAccountPaymentField';
export { getBankValidationInfo } from './BankAccountPaymentField.helpers';
